export default __webpack_public_path__ + "static/media/QR.422cc7bc.png";